/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Groups_TabInputs */

const en_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups`)
};

const fr_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupes`)
};

const de_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppen`)
};

const it_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppi`)
};

const ru_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группы`)
};

const es_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos`)
};

const zh_cn2_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团体`)
};

const ja_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ`)
};

const hi_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह`)
};

const pt_pt2_team_manager_groups_tab = /** @type {(inputs: Team_Manager_Groups_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos`)
};

/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Team_Manager_Groups_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_groups_tab = /** @type {((inputs?: Team_Manager_Groups_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Groups_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_groups_tab(inputs)
	if (locale === "de") return de_team_manager_groups_tab(inputs)
	if (locale === "it") return it_team_manager_groups_tab(inputs)
	if (locale === "ru") return ru_team_manager_groups_tab(inputs)
	if (locale === "es") return es_team_manager_groups_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_groups_tab(inputs)
	if (locale === "ja") return ja_team_manager_groups_tab(inputs)
	if (locale === "hi") return hi_team_manager_groups_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_groups_tab(inputs)
	return en_team_manager_groups_tab(inputs)
});